import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { User } from "../../../model/user";
import { UserGroupManagement } from "../../../model/userGroupManagement";
import { SnackbarService } from "../../../service/snackbar.service";

@Component({
  selector: 'app-add-user-dialog',
  templateUrl: './add-user-dialog.component.html',
  styleUrls: ['./add-user-dialog.component.css']
})
export class AddUserDialogComponent implements OnInit {

  selection: string;
  mail: string = '';
  pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  constructor(public dialogRef: MatDialogRef<AddUserDialogComponent>,
              private snackBarService: SnackbarService,
              @Inject(MAT_DIALOG_DATA) public dialogData: {user: User, groups: UserGroupManagement[] }) { }

  ngOnInit(): void {
    this.selection = this.dialogData.groups[0].userGroup.name;
  }

  selectGroup(value: string) {
    this.selection = value;
  }

  save():void {
    if(this.checkMail()) {
      this.dialogRef.close({userMail: this.mail, userGroupName: this.selection});
    } else {
      this.snackBarService.showSnackbar("Ungültige E-Mail", false);
    }
  }

  private checkMail(): boolean {
    return this.pattern.test(this.mail);
  }

  cancel():void {
    this.dialogRef.close();
  }

}
